import { Controller } from "@hotwired/stimulus"
import { useDocumentListener, useWindowListener } from 'lib/event_helpers';
import { fixHeight, animateHeight } from "lib/animator";
import { postRequestWindowUpdate, postChatStarted } from 'lib/post_messages';
import { updateParentWindowSize } from 'lib/window_helper';

const CHAT_STARTED_CLASS = 'chat--started';

export default class extends Controller {
  static targets = ['header', 'miniHeader'];
  static values = { organization: String, organizationId: String, userId: String };

  connect() {
    // Track application details
    this.application.dewey.organization = { name: this.organizationValue, id: this.organizationIdValue };
    if (this.hasUserIdValue) {
      this.application.dewey.user = { id: this.userIdValue };
    }

    // Listen for messages from the parent document
    useWindowListener(this, 'message', (event) => {
      let eventName;
      const { data } = event;
      if (typeof data === 'string') eventName = data;
      else eventName = data.name;

      switch (eventName) {
        case 'dewey--window-update':
          updateParentWindowSize(data.width, data.height);
          break;
      }
    });
    postRequestWindowUpdate();

    // Animate chat starting
    useDocumentListener(this, 'chat--form:requested', () => {
      // Ensure this only runs once
      if (!document.body.classList.contains(CHAT_STARTED_CLASS)) {
        // Make the height of the header and buffer static so we can
        // use CSS transitions to get rid of them
        const fixedElements = [];
        if (this.hasHeaderTarget)
          fixedElements.push(this.headerTarget)

        fixedElements.forEach((element) => {
          fixHeight(element);
        });

        // If we have a mini-header, let's animate it appearing
        if (this.hasMiniHeaderTarget)
          animateHeight(this.miniHeaderTarget, this.chatStarted);
        else
          requestAnimationFrame(() => { this.chatStarted(); });
      }
    });
  }

  chatStarted() {
    // Add a special class to the body to adapt layouts for
    // when we've started a a conversation
    document.body.classList.add(CHAT_STARTED_CLASS);
    // Notify the parent window script that chat has started
    postChatStarted();
  }
}